export const COMPANY_INFO = {
  name: "Where's The Will",
  tagline: "Safekeeping Your Wishes, Securing Your Legacy",
  address: {
    street: "3008 Canton St",
    city: "Dallas",
    state: "TX",
    zip: "75226",
  },
  phone: "214-809-2111",
  email: "info@wheresthewill.com",
  hours: "Mon - Fri: 9AM - 5PM",
  price: 99,
  priceAfterPromo: 199,
};

export const NAV_LINKS = [
  { label: 'Features', href: '#features', id: 'features' },
  { label: 'How It Works', href: '#process', id: 'process' },
  { label: 'About', href: '#about', id: 'about' },
  { label: 'FAQ', href: '#faq', id: 'faq' },
];

export const FEATURES = [
  {
    number: '01',
    title: 'Fireproof Storage',
    description: 'Documents stored in fireproof safes within our secure, locked facility. Complete protection from physical damage.',
    icon: 'lock',
  },
  {
    number: '02',
    title: 'Verified Access',
    description: 'Only verified individuals with proper documentation can retrieve your will. No unauthorized access—ever.',
    icon: 'shield',
  },
  {
    number: '03',
    title: 'Family Peace of Mind',
    description: 'Your loved ones will know exactly where to find your important documents when they need them most.',
    icon: 'users',
  },
  {
    number: '04',
    title: 'Easy Updates',
    description: "Need to update your will? Walk in or mail us the new version and we'll securely replace the old one at no extra cost.",
    icon: 'edit',
  },
];

export const PROCESS_STEPS = [
  {
    number: '01',
    title: 'Register Online',
    description: 'Complete our simple form and pay the one-time $99 grand opening fee to get started.',
  },
  {
    number: '02',
    title: 'Submit Your Will',
    description: 'Walk in or mail your will to our secure Dallas facility—mailing is at our cost.',
  },
  {
    number: '03',
    title: 'Receive Your Card',
    description: 'Get a wallet card with your identifying info so a loved one knows who to contact when the time comes.',
  },
  {
    number: '04',
    title: 'Rest Easy',
    description: 'Know your wishes are protected and accessible to your loved ones. We also mail to and from you or your loved one.',
  },
];

export const PRICING_FEATURES = [
  'Secure fireproof safe storage',
  'Locked facility protection',
  'Wallet card with your identifying info',
  'Free will replacement & updates',
  'Walk in or mail in at our cost',
  'Mail to and from you or your loved one',
  'Store additional estate documents',
];

export const FAQ_ITEMS = [
  {
    question: 'Why would I need to store my will with you when efile exists?',
    answer: 'When filing a probate case, the court requires the original copy of the will.',
  },
  {
    question: 'How is my will stored at your facility?',
    answer: 'Your will is stored in a locked facility with fireproof safes. Each safe is individually secured, providing protection from fire, theft, and damage.',
  },
  {
    question: 'What documents do I need to retrieve a will?',
    answer: 'To retrieve a stored will, you must present a certified death certificate and valid government-issued photo ID. The wallet card provided at registration contains the info your loved one needs to contact us.',
  },
  {
    question: "Can someone access my will while I'm still living?",
    answer: 'No. We have strict verification procedures in place. Your will can only be retrieved upon presentation of a valid death certificate. No one can access your will while you are living without your direct authorization.',
  },
  {
    question: "How do I update my will after it's stored?",
    answer: "Simply walk in or mail your updated will to our facility. We'll securely replace the old document with your new version at no additional charge. Mailing is at our cost.",
  },
  {
    question: 'What other documents can I store?',
    answer: 'In addition to your will, we can store Power of Attorney documents, healthcare directives, living wills, trust documents, property deeds, and insurance policies.',
  },
];

export const MARQUEE_ITEMS = [
  'Fireproof Storage',
  'Verified Access',
  'Dallas, Texas',
  'Peace of Mind',
  'Secure Storage',
];
